import logo from "@/assets/logo.png";
import { Heart } from "lucide-react";
import { Link } from "react-router-dom";
import { FooterGalleryPreview } from "./gallery/FooterGalleryPreview";
import { DonationTicker } from "./DonationTicker";

const Footer = () => {
  return (
    <footer className="bg-card/50 border-t border-border py-16">
      <div className="container">
        {/* Community Gallery Preview */}
        <FooterGalleryPreview />

        <div className="border-t border-border pt-8">
          <div className="flex flex-col md:flex-row items-center justify-between gap-6">
            {/* Logo and brand */}
            <div className="flex items-center gap-3 shrink-0">
              <img src={logo} alt="Go Fluff and Stuff" className="w-12 h-12" />
              <span className="font-display text-xl text-foreground">Go Fluff and Stuff</span>
            </div>

            {/* Links */}
            <nav className="flex flex-wrap items-center justify-center gap-x-6 gap-y-3 text-sm">
              <Link to="/" className="text-muted-foreground hover:text-foreground transition-colors whitespace-nowrap">
                Home
              </Link>
              <Link to="/about" className="text-muted-foreground hover:text-foreground transition-colors whitespace-nowrap">
                About
              </Link>
              <Link to="/terms" className="text-muted-foreground hover:text-foreground transition-colors whitespace-nowrap">
                Terms of Service
              </Link>
              <Link to="/privacy" className="text-muted-foreground hover:text-foreground transition-colors whitespace-nowrap">
                Privacy Policy
              </Link>
              <Link to="/refund-policy" className="text-muted-foreground hover:text-foreground transition-colors whitespace-nowrap">
                Refund Policy
              </Link>
              <Link to="/donation-discount" className="text-muted-foreground hover:text-foreground transition-colors whitespace-nowrap">
                Donation Discount
              </Link>
            </nav>

            {/* Social */}
            <div className="flex items-center gap-4 shrink-0">
              <a 
                href="https://www.facebook.com/groups/539899154034222" 
                target="_blank"
                rel="noopener noreferrer"
                className="text-muted-foreground hover:text-brand-blue transition-colors"
                aria-label="Facebook"
              >
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
                </svg>
              </a>
            </div>
          </div>

          {/* Copyright */}
          <div className="mt-8 pt-6 border-t border-border text-center space-y-2">
            {/* AVL Badge */}
            <p className="text-muted-foreground/70 text-xs leading-relaxed max-w-md mx-auto">
              Go Fluff and Stuff has been tested through and is listed on the{" "}
              <span className="text-foreground/60 font-medium">AVL with Sugar Glider Groupies</span>
              . We adhere to all sugar glider safety standards.{" "}
              <span className="text-muted-foreground/40 text-[10px]">Verified {new Date().toLocaleDateString("en-US", { month: "long", year: "numeric" })}</span>
            </p>
            <DonationTicker variant="footer" />
            <p className="text-muted-foreground text-sm flex flex-wrap items-center justify-center gap-1">
              © {new Date().getFullYear()} Go Fluff and Stuff. Made with <Heart className="h-4 w-4 text-brand-pink fill-brand-pink" /> for sugar glider lovers everywhere.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
